import { MatrixRowColumnModel, McqOptionModel } from "./mcq-option.model";
import { MatrixAnswerModel, McqAnswerModel } from "./SurveySubmission.model";

export class QuestionModel {
    public questionId: number = 0;
    
    public questionEn: string = '';
    public questionFr: string = '';
    public question: string = '';
    
    public placeholderEn: string = '';
    public placeholderFr: string = '';
    public placeholder: string = '';    
    
    public errorMessageEn: string = '';
    public errorMessageFr: string = '';
    public errorMessage: string = '';
    
    public groupId: number = 0;
    public questionTypeId: number = 1;

    public isMandatory: boolean = false;
    public maxCharacterLimit: number = 10;
    public code: string = 'TEXT';
    public defaultRegex: string = '';
    public isValid: boolean = true;
    public value: string = '';

    public maxMcqValues: number = -1;
    public minMcqValues: number = -1;
    
    public mcqOptions: McqOptionModel[] = [];
    public mcqAnswers: McqAnswerModel[] = [];

    public matrixAnswers: MatrixAnswerModel[] = [];

    public matrixRows: MatrixRowColumnModel[] = [];
    public matrixColumns: MatrixRowColumnModel[] = [];

}